const IGNORE_YEAR_AT_A_GLANCE_ITEMS = ['subscriptionPtsEarned'];
const ICON_TYPES_TO_IGNORE = ['refer', 'BLANK (NO OPTION)'];

export {
    IGNORE_YEAR_AT_A_GLANCE_ITEMS, ICON_TYPES_TO_IGNORE
};
